import {
	Button, Icon
} from "~/components";
import { Tooltip } from "antd";
import {useNavigate} from "react-router-dom";

function ProductAction({ item, onEdit, onDelete, can}) {

	const navigate = useNavigate();

	const buttonHandlers = {
		edit: () => {
			navigate(`/product/edit/${item.id}`);
		},
		delete: () => {
			if(onDelete) onDelete(item);
		}
	};

	return (
		<div className="table-action d-flex">
			{(can.edit ) && (<Tooltip title="Cập nhật thông tin"><Button small background blue noneBorder leftIcon={Icon.edit} onClick={buttonHandlers.edit} /></Tooltip>)}
			{can.delete && (
				<Tooltip title="Xóa sản phẩm">
					<Button small background red noneBorder leftIcon={Icon.delete} onClick={buttonHandlers.delete} />
				</Tooltip>
			)}
		</div>
	);
}

export default ProductAction;
